import {Injectable} from '@angular/core';

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    name: string;
    type?: string;
}

export interface Menu {
    baseState?: string;
    state: string;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
    needAdmin?: boolean; //if needs admin, check for admin session
}

const MENUITEMS = [
    {
        state: '/',
        name: 'Dashboard',
        type: 'link',
        icon: 'dashboard'
    },
    {
        state: 'works',
        name: 'Tasks',
        type: 'link',
        // icon: 'medication'
        icon: 'receipt_long'
    },
    // {
    //     state: 'medical-services',
    //     name: 'Servicios',
    //     type: 'link',
    //     icon: 'assignment'
    // },
    // {
    //     state: 'patients',
    //     name: 'Pacientes',
    //     type: 'link',
    //     icon: 'group'
    // },
    // {
    //     state: 'external-companies',
    //     name: 'Customers',
    //     type: 'link',
    //     icon: 'business'
    //     // icon: 'subtitles'
    // },
    // {
    //     state: 'external-doctors',
    //     name: 'Médicos',
    //     type: 'link',
    //     icon: 'medication'
    // },

    /** ADMIN MENU **/

    {
        state: 'account',
        name: 'Sanlor',
        type: 'link',
        icon: 'science',
        needAdmin: true,
    },
    {
        state: 'users',
        name: 'Usuarios',
        type: 'link',
        icon: 'account_circle',
        needAdmin: true,
    },
    {
        state: 'branches',
        name: 'Sucursales',
        type: 'link',
        icon: 'add_location',
        needAdmin: true,
    },
    {
        state: 'discounts',
        name: 'Descuentos',
        type: 'link',
        icon: 'money_off',
        needAdmin: true,
    },
    {
        state: 'inventory',
        name: 'Inventario',
        type: 'link',
        icon: 'checklist',
        needAdmin: true,
    },
    {
        state: 'studies',
        name: 'Estudios',
        type: 'sub',
        icon: 'insights',
        children: [
            {state: 'catalog', name: 'Catálogo'},
            //{state: 'categories', name: 'Categorías'},
            {state: 'samples', name: 'Tipos de muestras'},
            {state: 'prerequisites', name: 'Pre-requisitos'},
            {state: 'labs', name: 'Laboratorios externos'},
        ],
        needAdmin: true,
    },
];

@Injectable()
export class MenuItems {
    getAll(): Menu[] {
        return MENUITEMS;
    }

    add(menu: Menu) {
        MENUITEMS.push(menu);
    }
}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/menu-items/menu-items.ts